import {ManualImportControllerName} from "../utils/names/controllerNames";
import {ManualImportServiceName} from "../utils/names/serviceNames";
import {ManualImportService} from "./services/ManualImportService";
import {ManualPullLogComponent} from "./components/manual_import_log_list/manual-pull-log.component";
import {ManualPullLogHeaderComponent} from "./components/manual_import_log_header/manual-pull-log-header.component";
import ManualImportModuleConfiguration from "./ManualImportModuleConfiguration";
import {ManualImportController} from "./route/manual-import";
import {ImportContactDialogComponent} from "./components/import-contacts/import-contact-dialog.component";


ManualImportModuleConfiguration.createNewModule()
    .controller(ManualImportControllerName, ManualImportController.instance)
    .service(ManualImportServiceName, ManualImportService.instance)
    .component('manualImportReportHeader', ManualPullLogHeaderComponent.instance)
    .component('manualImportPullLog', ManualPullLogComponent.instance)
    .component('importContactDialog', ImportContactDialogComponent.instance)